export const SITE_NAME = "SCargo";

export const KEY_TOKEN = "cargoadmin_token";
export const KEY_AUTH_HEADER = "x-auth";
export const KEY_AUTH_BEARER = "snvniscndoveh";

export const API_URL = "https://app.scargohn.com/api";
export const API_URL_DEV = "";

export const APP_DEFAULT_CLIENT_HOME_ROUTE = "/dashboard/paquetes";
export const APP_DEFAULT_ADMIN_HOME_ROUTE = "/admin";

export const APP_MAX_PAGES_PAGINATION = 10;
export const APP_PAGINATION_PAGES_VARIATION = 3;
